export default {
    pending: 1,
    sent: 2,
    success: 3,
    cancelled: 4,
    rejected: 5,
    liquidated: 6,
    observed: 7
};
